import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Collapse, Form, Input, Select, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { GroupFormSelect } from "~/components/form/GroupFormSelect.jsx";
import { HelpLine } from "~/components/help/helpLine.jsx";
import { useSyncData } from "~/compositions/state.js";
import { $t } from "~/i18n.js";


export const DienstTemplate = ({ value = [], onChange, hasAutofill, users }) => {
  const [activeKey, setActiveKey] = useState([]);

  const handleAdd = () => {
    const newDienst = {
      id: `new_${value.length}`,
      name: $t("Nieuwe dienst"),
      groups: [],
      exclude_groups: [],
      exclude_users: [],
      autofill: "blank",
    };
    onChange([...value, newDienst]);
    setActiveKey([value.length.toString()]);
  };

  const { updateBaseIfRequired } = useSyncData();
  useEffect(() => {
    updateBaseIfRequired();
  }, []);

  const handleDelete = (index) => {
    const newValue = value.map((d, i) => {
      if (i === index) return { ...d, delete: !d.delete };
      return d;
    });
    onChange(newValue);
  };

  const handleUpdate = (index, field, fieldValue) => {
    const newValue = [...value];
    newValue[index] = { ...newValue[index], [field]: fieldValue };
    onChange(newValue);
  };

  return (
    <div>
      <HelpLine>
        {$t(
          "Diensten zijn vooral geschikt bij specifieke rollen die (veelal) vooraf ingeroosterd worden, denk aan startleiders of instructeurs."
        )}
      </HelpLine>

      <Collapse
        activeKey={activeKey}
        onChange={setActiveKey}
        style={{ marginTop: 12 }}
        items={value.map((dienst, index) => ({
          key: index.toString(),
          label: dienst.name,
          extra: (
              <div className="row" style={{ gap: 6 }}>
                {dienst.delete && <Tag color="red">{$t("Verwijderen")}</Tag>}
                <Button
                  key="delete"
                  danger
                  shape="circle"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(index);
                  }}
                  icon={<DeleteOutlined />}
                />
              </div>
            ),
          children: (
            <Form
              layout="horizontal"
              size="small"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
            >
              <Form.Item label={$t("Naam")}>
                <Input
                  value={dienst.name}
                  onChange={(e) => handleUpdate(index, "name", e.target.value)}
                  placeholder={$t("Naam van de dienst")}
                />
              </Form.Item>

              <Form.Item
                label={$t("Groepen")}
                extra={$t(
                  "Optioneel, limiteer de groepen die ingeroosterd kunnen worden"
                )}
              >
                <GroupFormSelect
                  value={dienst.groups}
                  onChange={(val) => handleUpdate(index, "groups", val)}
                />
              </Form.Item>

              <Form.Item
                label={$t("Groepen uitsluiten")}
                extra={$t(
                  "Optioneel, sluit de groepen uit die ingeroosterd worden, alleen tijdens het roosteren"
                )}
              >
                <GroupFormSelect
                  value={dienst.exclude_groups || []}
                  onChange={(val) => handleUpdate(index, "exclude_groups", val)}
                />
              </Form.Item>

              {users && (
                <Form.Item
                  label={$t("Gebruikers uitsluiten")}
                  extra={$t(
                    "Optioneel, sluit specifieke gebruikers uit die ingeroosterd worden, alleen tijdens het roosteren"
                  )}
                >
                  <Select
                    mode="multiple"
                    value={dienst.exclude_users || []}
                    onChange={(val) => handleUpdate(index, "exclude_users", val)}
                    filterOption={(input, option) => {
                      return (
                        option &&
                        option.children &&
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                    style={{ width: "100%" }}
                  >
                    {users
                      ?.filter((u) => dienst.groups.length > 0 ? dienst.groups?.some((g) => u.group_keys?.includes(g)) : true)
                      .map((user, key) => (
                        <Select.Option value={user.id} key={key}>
                          {user.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              )}

              {hasAutofill && (
                <Form.Item
                  label={$t("Rooster methode")}
                  extra={$t(
                    "Hoe de dienst ingevuld wordt bij het aanmaken van roosters"
                  )}
                >
                  <Select
                    value={dienst.autofill || "blank"}
                    style={{ width: "100%" }}
                    onChange={(value) => handleUpdate(index, "autofill", value)}
                  >
                    <Select.Option value="blank">{$t("Leeg")}</Select.Option>
                    <Select.Option value="autofill">{$t("Auto")}</Select.Option>
                    <Select.Option value="social">
                      {$t("Sociaal")}
                    </Select.Option>
                  </Select>
                </Form.Item>
              )}
            </Form>
          ),
        }))}
      />

      {value.length === 0 && (
        <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>
          {$t("Geen diensten")}
        </div>
      )}

      <Button
        style={{ marginTop: 12 }}
        type="dashed"
        icon={<PlusOutlined />}
        onClick={handleAdd}
      >
        {$t("Dienst toevoegen")}
      </Button>
    </div>
  );
};
